import {
  updateResourceState,
  createResourceReducer,
  normalizeResourceState,
  RESOURCE
} from '@unicus/react-ui-kit';
import {
  CATEGORY,
  CATEGORY_FETCH,
  CATEGORY_FETCH_FINISHED
} from './categoryActions';

const categoryReducer = createResourceReducer(CATEGORY, [], {
  [CATEGORY_FETCH](state, action) {
    const newState = normalizeResourceState(state, action.resource);

    return updateResourceState(newState, action, RESOURCE, () => ({
      loading: true
    }));
  },

  [CATEGORY_FETCH_FINISHED](state, action) {
    const newState = normalizeResourceState(state, action.resource);

    return updateResourceState(newState, action, RESOURCE, () => ({
      items: action.payload.data.result,
      queryParams: action.payload.config.params,
      editing: false,
      saving: false,
      loading: false,
      loaded: true
    }));
  }
});

export default categoryReducer;
